<template>
  <div>
    <Map
      :layers="mapLayers"
      @show-detail="showDetail"
    />
    <div class="pl-5">
      <div class="container flex flex-row">
        <div class="filter-container">
          <StatusCards
            :loaded-text="`${loadedCount} units`"
            :empty-text="`${emptyCount} units`"
            :docking-text="`${dockingCount} Units`"
            :active-status="tugboatStatusFilter"
            @filter="onStatusCardFilter"
          />
          <map-filter
            v-show="!isShipDetailShown"
            :tugboats="tugboatOptions"
            :companies="companyOptions"
            :barge-statuses="bargeStatusOptions"
            :locations="locationOptions"
            :ports="portOptions"
            @reset="fetchAdvanceFilter"
            @advance-filter="fetchAdvanceFilter"
            @location-filter="fetchAdvanceFilter"
            @show-trip="fetchAdvanceFilter"
            @download="downloadExcel"
            @reset-selected-vessel="resetSelectedVessel"
          />
          <!-- <map-ship-detail
            class="mt-5"
            :is-shown="isShipDetailShown"
            :type="detailType"
            :detail-data="detail"
            style="z-index: 9;"
            @close="isShipDetailShown = false"
          /> -->
        </div>
      </div>
      <div class="telematic-sidebar">
        <img
          src="../../assets/shipo-icon-vessel.svg"
          @click="handlePopUpOnClick(VESSEL_TYPE())"
        >
        <img
          src="../../assets/shipo-icon-barge.svg"
          @click="handlePopUpOnClick(TUG_TYPE())"
        >
        <img
          src="../../assets/shipo-icon-docking-barge.svg"
          @click="handlePopUpOnClick(DOCKING_BARGE_TYPE())"
        >
      </div>
    </div>
    <!--      <map-ship-pop-up-->
    <!--        class="pop-up-container"-->
    <!--        :is-shown.sync="isPopUpShown"-->
    <!--        :ship-type="popUpType"-->
    <!--        :ships="popUpType === 'vessel' ? vesselTransactions : tugboatData"-->
    <!--        @search="fetchByFilter"-->
    <!--      />-->
    <map-ship-detail
      class="pop-up-detail-container"
      :is-shown="isShipDetailShown"
      :is-check-point="isCheckPoint"
      :type="detailType"
      :detail-data="detail"
      :chart-data.sync="chartData"
      :chart-options="chartOptions"
      :filter-poi-options="filterPoiOptions"
      style="z-index: 9;"
      @close="handleDetailClose"
      @setChartData="val => chartData = val"
      @filterFleet="handleFilterFleet"
    />
    <map-list-pop-up
      class="pop-up-container"
      :is-shown.sync="isPopUpListShown"
      :ship-type.sync="popUpType"
      :detail-type.sync="detailType"
      :detail.sync="detail"
      :ships="popUpType === VESSEL_TYPE() ? vesselList.filter(item => selectedVessel ? selectedVessel.name === item.vessel_name : item) : filteredTugboats.filter(item => selectedVessel ? selectedVessel.name === item.vessel_name : item)"
      :selected-vessel-id="selectedVessel ? selectedVessel.id : null"
      @search="fetchByFilter"
      @refocus="setMapView"
      @filterByVessel="filterByVessel"
    />
  </div>
</template>


<script>
import {uniqBy} from "lodash";
import moment from 'moment'
import { parse } from 'svgson'
import { mapGetters } from 'vuex'

import Map from '@/components/arcgisMap'
import MapFilter from '@/components/mapFilter'
import MapListPopUp from "@/components/mapListPopUp";
import MapShipDetail from '@/components/mapShipDetail'
import StatusCards from '@/components/statusCards'
import {
  COLOR_TUGBOAT_DEFAULT, DOCKING_BARGE_TYPE, FILTER_LAST_POSITION, FILTER_TRIP,
  INTERVAL_FETCH_TELEMATICS_IN_SECONDS,
  KEY_POI_PORT,
  LAYER_ID_POI, LAYER_ID_TRIP, LAYER_ID_TRIP_LINE,
  LAYER_ID_TUGBOAT,
  LAYER_ID_VESSEL,
  PAGE_TITLE,
  TUG_TYPE,
  VESSEL_TYPE
} from '@/fixtures/Constants'
import EventBus from '@/plugins/EsriEventBus'
import downloadUtils from '@/utils/downloadUtils'

export default {
  components: {
    Map,
    MapFilter,
    MapListPopUp,
    MapShipDetail,
    StatusCards
  },
  metaInfo: {
    title: `${PAGE_TITLE} Home`
  },
  data() {
    const revenueData = [100, 200, 150, 300, 250];

    return {
      isPopUpShown: false,
      isPopUpListShown: false,
      isShipDetailShown: false,
      popUpType: null,
      detailType: null,
      detail: null,
      tugboatOptions: [],
      selectedVessel: null,
      companyOptions: [],
      bargeStatusOptions: [],
      locationOptions: [],
      portOptions: [],
      mapLayers: [
        LAYER_ID_POI,
        LAYER_ID_TUGBOAT,
        LAYER_ID_VESSEL,
        LAYER_ID_TRIP,
        LAYER_ID_TRIP_LINE
      ],
      filter: null,
      searchState: FILTER_LAST_POSITION,
      tugboatList: [],
      vesselList: [],
      tugboatStatusFilter: null,
      tugboatListSearch: null,
      chartData: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
        datasets: [
          {
            type: 'line',
            label: 'Revenue',
            data: revenueData,
            backgroundColor: revenueData.map(() => this.getRandomColor())
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              filter: (legendItem) => legendItem.datasetIndex !== 0 // Hide first dataset (bar)
            }
          },
          title: {
            display: false
          }
        },
        scales: {
          x: {
            offset: true,
            grid: { display: false }
          },
          y: {
            beginAtZero: false,
            offset: true,
            grid: { display: false }
          }
        }
      },
      filterPoiOptions: [],
      isCheckPoint: false
    }
  },
  computed: {
    ...mapGetters({
      tugs: 'MonitoringReport/tugsNames',
      companies: 'MonitoringReport/companies',
      bargeStatuses: 'Home/bargeStatuses',
      locations: 'Home/locations',
      ports: 'Home/ports',
      tugboatData: 'Home/tugboatData',
      tugboatPositions: 'Home/tugboatPositions',
      tugboatFile: 'Home/tugboatFile',
      vesselTransactions: 'Home/vesselTransactions'
    }),
    loadedCount() {
      return this.tugboatPositions.filter(tb => tb.coal > 0 && (tb.is_docking === false || tb.is_docking === 'N/A')).length;
    },
    emptyCount() {
      return this.tugboatPositions.filter(tb => tb.coal === 0 && (tb.is_docking === false || tb.is_docking === 'N/A')).length;
    },
    dockingCount() {
      return this.tugboatPositions.filter(tb => tb.is_docking === true).length;
    },
    filteredTugboats() {
      if (!this.tugboatStatusFilter) return this.tugboatList;
      if (this.tugboatStatusFilter === 'Loaded') {
        return this.tugboatData.filter(tb => (tb.coal > 0 && (tb.is_docking === false || tb.is_docking === 'N/A')));
      }
      if (this.tugboatStatusFilter === 'Empty') {
        return this.tugboatData.filter(tb => tb.coal === 0 && (tb.is_docking === false || tb.is_docking === 'N/A'));
      }
      if (this.tugboatStatusFilter === 'Docking') {
        return this.tugboatData.filter(tb => tb.is_docking === true);
      }
      return this.tugboatData;
    }
  },
  watch: {
    tugs: {
      handler(val) {
        this.tugboatOptions = val.map(item => ({ value: item.id, text: item.tugboat_name }))
      }
    },
    companies: {
      handler(val) {
        this.companyOptions = val.map(item => ({ value: item.id, text: item.name }))
      }
    },
    bargeStatuses: {
      handler(val) {
        this.bargeStatusOptions = val
      }
    },
    locations: {
      handler(val) {
        this.locationOptions = val.map(item => ({ value: item.alias, text: item.name }))
      }
    },
    ports: {
      handler(val) {
        this.portOptions = val.map(item => ({ value: item.alias, text: item.alias }))
      }
    },
    tugboatPositions: {
      handler(val) {
        if (val) {
          if (this.searchState === FILTER_TRIP) {
            this.generateTripGraphics(val)
          } else {
            this.tugboatList = val.filter(({ type }) => type === 'tugboat').filter(item => this.selectedVessel ? item.vessel_name === this.selectedVessel.name : item)
            this.fetchByFilter(undefined,undefined,true)
          } 

          if (this.vesselList) {
            this.vesselList
              .forEach((vessel) => {
                const filteredTugboats = this.tugboatList.filter((tug) => tug.vessel_name === vessel.vessel_name.trim())
                const dataVesselFromTugboats = val.filter(tug => tug.type === VESSEL_TYPE  &&  tug.vessel_name.trim() === vessel.vessel_name.trim())
                if (dataVesselFromTugboats.length) {
                  const selectedDataFromTugboats = dataVesselFromTugboats.find(dt => dt.vessel_name.trim() === vessel.vessel_name.trim())
                  if(selectedDataFromTugboats.hasOwnProperty('marine_traffic_information')) {
                    vessel['eta'] = selectedDataFromTugboats.marine_traffic_information.hasOwnProperty('eta') ? selectedDataFromTugboats.marine_traffic_information.eta : null
                  } else {
                    vessel['eta'] = null
                  }
                }
                if (filteredTugboats.length) {
                  vessel['tugboats'] = filteredTugboats
                }
                const vesselFromTugboatPosition = val.find((v) => v.vessel_name && v.vessel_name === vessel.vessel_name && v.type === 'vessel')
                if(vesselFromTugboatPosition) {
                  vessel['latitude'] = vesselFromTugboatPosition.latitude
                  vessel['longitude'] = vesselFromTugboatPosition.longitude
                  vessel['marine_traffic_information'] = vesselFromTugboatPosition.marine_traffic_information
                }
              })
          }
        }
      }
    },
    vesselTransactions: {
      handler(val) {
        if (val) {
          let updatedVal = val
            .map((item) => ({
              ...item,
              id: item?.vessel_id
            }))
          updatedVal = updatedVal
            .map((item) => {
              const filteredTugboats = this.tugboatList.filter((tug) => tug.vessel_name === item.vessel_name.trim())
              if (filteredTugboats.length) {
                return {
                  ...item,
                  tugboats: filteredTugboats
                }
              }
              return item
            })
          this.vesselList = updatedVal
        }
      }
    },
    tugboatFile: {
      handler(val) {
        if (val) {
          downloadUtils(val, `telematics_${this.moment().format('DD_MMM_YYYY_HH_mm_ss')}.xls`)
          this.$store.dispatch('Home/resetTugboatFile')
        }
      }
    },
    isPopUpListShown: {
      handler(val) {
        if(!val && this.popUpType && !this.isShipDetailShown) {
          this.popUpType = null
        }
      }
    },
    tugboatData: {
      handler(val) {
        if (val) {
          this.tugboatList = uniqBy(val.filter(({ type }) => type === 'tugboat'), 'id')
        }
      }
    },
    filteredTugboats: {
      handler(newVal) {
        this.removeGraphics();
        if (this.tugboatStatusFilter) {
          this.generateShipGraphics(newVal.filter(v => this.selectedVessel ? v.vessel_name === this.selectedVessel.name : v ));
          if (this.tugboatStatusFilter === 'Loaded') {
            this.generateShipGraphics(this.vesselList.filter(v => this.selectedVessel ? v.vessel_name === this.selectedVessel.name : v ));
            // Show Location POD when filter Loaded is active
            this.generatePoiGraphics(this.tugboatPositions.filter(tb => tb?.type_port?.toLowerCase() === 'pod'));
          }
        } else {
          this.generateShipGraphics(this.filteredTugboats.filter(ft => this.selectedVessel ? ft.vessel_name === this.selectedVessel.name : ft ));
          this.generateShipGraphics(this.vesselList.filter(v => this.selectedVessel ? v.vessel_name === this.selectedVessel.name : v ));
          this.generatePoiGraphics(this.tugboatPositions);
        }
      }
    },
    tugboatStatusFilter: {
      handler() {
        this.isPopUpListShown = false
      }
    }
  },
  mounted() {
    EventBus.$on('map-ready', ()  => {
      this.startIntervalFetching()
      this.fetchVesselTransactions()
    })

    this.fetchTugs()
    this.fetchCompanies()
    this.fetchBargeStatuses()
    this.fetchLocations()
    this.fetchPorts()
    this.fetchTugboatPositions({ type: this.searchState })
    this.fetchTugboatPositions({ isPopUp: true })
  },
  destroyed() {
    this.stopIntervalFetching()
  },
  methods: {
    handleDetailClose() {
      this.isShipDetailShown = false
      this.fetchByFilter({ search: null }, undefined)
      this.isPopUpListShown = false
    },
    handleFilterFleet(val) {
      this.detailType = 'tugboat'
      this.isPopUpListShown = true
      this.fetchByFilter({ search: null }, this.detailType, false, val)
    },
    resetSelectedVessel() {
      this.selectedVessel = null
    },
    getRandomColor(alpha = 0.7) {
      const r = Math.floor(Math.random() * 156) + 100;
      const g = Math.floor(Math.random() * 156) + 100;
      const b = Math.floor(Math.random() * 156) + 100;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    TUG_TYPE() {
      return TUG_TYPE
    },
    DOCKING_BARGE_TYPE() {
      return DOCKING_BARGE_TYPE
    },
    VESSEL_TYPE() {
      return VESSEL_TYPE
    },
    async fetchTugs() {
      await this.$store.dispatch('MonitoringReport/fetchTugNames')
    },
    async fetchCompanies() {
      await this.$store.dispatch('MonitoringReport/fetchCompanies')
    },
    async fetchBargeStatuses() {
      await this.$store.dispatch('Home/fetchBargeStatuses')
    },
    async fetchLocations() {
      await this.$store.dispatch('Home/fetchLocations')
    },
    async fetchPorts() {
      await this.$store.dispatch('Home/fetchRoutes')
    },
    async fetchTugboatPositions({filter, type, isPopUp = false}) {
      if (type === FILTER_TRIP) {
        await this.$store.dispatch('Home/fetchTugboatRoutes', filter)
      } else {
        await this.$store.dispatch('Home/fetchTugboatPositions', { filter, isPopUp })
      }
    },
    async fetchTugboatRoutes(filter) {
      await this.$store.dispatch('Home/fetchTugboatRoutes', filter)
    },
    async fetchVesselTransactions(filter) {
      await this.$store.dispatch('Home/fetchVesselTransactions', filter)
    },
    async downloadExcel(filter) {
      if (this.searchState === FILTER_TRIP) {
        await this.$store.dispatch('Home/downloadFileRoutes', filter)
      } else {
        await this.$store.dispatch('Home/downloadFile', filter)
      }
    },
    async fetchAdvanceFilter({ filters, type }) {
      this.filter = filters
      this.searchState = type ? type : FILTER_LAST_POSITION
      this.stopIntervalFetching()
      this.removeGraphics()
      await this.fetchTugboatPositions({
        filter: this.filter,
        type: this.searchState
      })
      await this.startIntervalFetching()
    },
    async fetchByFilter(filter = { search: this.tugboatListSearch }, shipType = 'tugboat', isRefetch = false, filteredFleetIds = null) {
      this.resetSelectedVessel()
      this.filterByVessel()
      if (shipType === VESSEL_TYPE) {
        await this.fetchVesselTransactions(filter)
      } else {
        if (filteredFleetIds?.length && !isRefetch) {
          this.tugboatList = this.cloneDeep(this.tugboatListAll)
          this.tugboatList = this.tugboatList.filter(val => filteredFleetIds.includes(val.id))
          return
        }
        if (this.isEmpty(this.tugboatListAll) || isRefetch) {
          this.tugboatListAll = this.cloneDeep(this.tugboatList)
        }
        if (!this.isEmpty(filter.search)) {
          this.tugboatListSearch = filter.search;
          this.tugboatList = this.cloneDeep(this.tugboatListAll)
          const term = filter.search.toLowerCase()

          this.tugboatList = this.tugboatList.filter(obj =>
            Object.values(obj).some(value =>
              String(value).toLowerCase().includes(term)
            )
          )
        } else {
          this.tugboatListSearch = null;
          this.tugboatList = this.cloneDeep(this.tugboatListAll)
        }
      }
    },
    // affected when separate location from api /tugboats-position 
    async generatePoiGraphics(data) {
      const portIcon = require('!!raw-loader!../../assets/shipo-map-poi-new.svg').default
      const bridgeIcon = require('!!raw-loader!../../assets/shipo-map-bridge-red.svg').default
      const portIconJson = await parse(portIcon)
      const bridgeIconJson = await parse(bridgeIcon)
      const portIconPath = portIconJson.children[0].attributes.d
      const bridgeIconPath = bridgeIconJson.children[0].attributes.d
      const iconColor = portIconJson.children[0].attributes.fill
      const iconOutlineWidth = portIconJson.children[0].attributes['stroke-width']
      EventBus.$emit('map-add-areas', {
        layerId: LAYER_ID_POI,
        graphics: data
          .filter(({ type }) => type === LAYER_ID_POI)
          .flatMap(item => {
            if (item.poi_type === KEY_POI_PORT) {
              return this.drawPort(item, portIconPath, iconColor, iconOutlineWidth)
            } else if (item.poi_type === 'Bridge') {
              return this.drawBridge(item, bridgeIconPath)
            }
            
            return this.drawPoi(item)
          })
      })
    },
    async generateShipGraphics(data) {
      const tugIcon = require('!!raw-loader!../../assets/shipo-map-tug-new.svg').default
      const vesselIcon = require('!!raw-loader!../../assets/shipo-map-vessel-1.svg').default
      const tugIconJson = await parse(tugIcon)
      const vesselIconJson = await parse(vesselIcon)

      const tugIconPath = tugIconJson.children[0].attributes.d
      const vesselIconPath = vesselIconJson.children[0].attributes.d
      EventBus.$emit('map-add-graphics', {
        layerId: LAYER_ID_TUGBOAT,
        graphics: data
          .filter(({ type }) => type === TUG_TYPE)
          .map(item => this.drawGraphics(
            item,
            tugIconPath,
            12
          ))
      })
      EventBus.$emit('map-add-graphics', {
        layerId: LAYER_ID_VESSEL,
        graphics: data
          .filter(({ type }) => type === VESSEL_TYPE)
          .map(item => this.drawGraphics(
            item,
            vesselIconPath,
            30,
            { width: 0.5 }
          ))
      });
    },
    async generateTripGraphics(data) {
      const tugIcon = require('!!raw-loader!../../assets/shipo-map-tug-new.svg').default
      const tugIconJson = await parse(tugIcon)

      const tugIconPath = tugIconJson.children[0].attributes.d

      const tugData = data
        .filter(({ type }) => type === TUG_TYPE)
        .sort((a, b) => {
          if (moment(a.position_time).isBefore(b.position_time)) return -1;
          else if (moment(a.position_time).isAfter(b.position_time)) return 1;
          return 0;
        })

      const start = tugData[0];
      const end = tugData[tugData.length - 1];

      EventBus.$emit('map-add-graphics', {
        layerId: LAYER_ID_TRIP,
        graphics: tugData
          .slice(1, tugData.length - 1)
          .map(item => this.drawGraphics(
            item,
            tugIconPath,
            15,
            item.speed > 0
              ? { color: '#28A745', width: 0.25 }
              : { width: 0.25 }
          ))
      })

      EventBus.$emit('map-add-lines', {
        layerId: LAYER_ID_TRIP_LINE,
        lines: [
          this.drawLine(
            start,
            tugData.map(t => ([t.longitude, t.latitude]))
          )
        ]
      })

      EventBus.$emit('map-add-graphics', {
        layerId: LAYER_ID_TRIP_LINE,
        graphics: [start, end]
          .map(item => this.drawGraphics(
            item,
            tugIconPath,
            30,
            item === start
              ? { color: 'blue', width: 0.25 }
              : { color: 'red', width: 0.25 }
          ))
      })
    },
    async startIntervalFetching() {
      try {
        await this.fetchTugboatPositions({
          filter: this.filter,
          type: this.searchState
        })
      } catch (err) {
        // catch error get data tugboats-position
      } finally {
        this.stopIntervalFetching()

        window.tugboatPositionsInterval = setInterval(async () => {
          await this.fetchTugboatPositions({
            filter: this.filter,
            type: this.searchState
          })
        }, INTERVAL_FETCH_TELEMATICS_IN_SECONDS)
      }
    },
    handlePopUpOnClick(type) {
      this.isPopUpShown = !this.isPopUpShown
      const isShipTypeChange = this.popUpType !== type
      this.isPopUpListShown = isShipTypeChange
      this.popUpType = isShipTypeChange ? type : this.popUpType
    },
    stopIntervalFetching() {
      clearInterval(window.tugboatPositionsInterval)
      window.tugboatPositionsInterval = undefined
    },
    drawPort(attr, path, color) {
      const iconGraphic = {
        geometry: {
          type: 'point',
          latitude: attr.latitude,
          longitude: attr.longitude
        },
        symbol: {
          type: 'simple-marker',
          color: attr.color ?? color,
          path,
          size: 20
        },
        attr
      }

      const labelGraphic = {
        geometry: {
          type: 'point',
          latitude: attr.latitude + 0.0008, // adjust offset for zoom level
          longitude: attr.longitude
        },
        symbol: {
          type: 'text',
          text: attr.name || 'Port',
          color: 'black',
          font: {
            size: 8,
            family: 'Arial'
          },
          haloColor: 'white',
          haloSize: 1,
          yoffset: 10 // pushes text slightly above the marker
        },
        attributes: attr
      }
      
      return [iconGraphic, labelGraphic]
    },
    drawPoi(attr) {
      // ini draw point kecil ungu
      return [{
        geometry: {
          center: [
            attr.longitude,
            attr.latitude
          ],
          radius: attr.radius
        },
        symbol: {
          type: 'simple-marker',
          color: '#6546C3',
          size: 5,
          outline: {
            color: '#FFFFFF',
            width: 1
          }
        },
        attr
      }]
    },
    drawGraphics(attr, path, size, outline = ({ width: 0 })) {
      const hexColor = this.handleColorLogic(attr)
      
      if (hexColor.outline) {
        outline = {
          color: hexColor.outline,
          width: 2
        }
      }

      return {
        geometry: {
          type: 'point',
          latitude: attr.latitude,
          longitude: attr.longitude
        },
        symbol: {
          type: 'simple-marker',
          color: hexColor.color,
          path,
          size,
          angle: attr.heading,
          outline
        },
        attr
      }
    },
    handleColorLogic(attr) {
      if (attr.type === 'vessel') {
        return {
          color: attr.color,
          outline: null
        }
      }
      const isLoaded = attr.loading_end && (attr.unloading_end || (attr.has_return_cargo && !attr.unloading_end_2))
      // Delayed
      if (attr.is_delay) {
        return {
          color: '#FFAA00',
          outline: attr.coal > 0 || isLoaded ? attr.color : null
        }
      }
      // Docking
      if (attr.is_docking && attr.is_docking !== 'N/A') {
        return {
          color: '#EE443F',
          outline: null
        }
      }
      // Empty from SMD
      if (
        (!attr.is_blu_available && (!attr.is_docking || attr.is_docking === 'N/A'))
        || (attr.is_blu_available && !attr.loading_end)
      ) {
        return {
          color: 'rgba(140, 142, 152, .6)',
          outline: null
        }
      }
      // Empty from Vessel/Port
      if (
        attr.is_blu_available && 
        attr.unloading_end && 
        (!attr.has_return_cargo || attr.unloading_end_2)
      ) {
        return {
          color: 'rgba(140, 142, 152, .6)',
          outline: attr.color
        }
      }
      // Loaded
      if (isLoaded) {
        return {
          color: attr.color,
          outline: null
        }
      }
      return {
        color: attr?.color || COLOR_TUGBOAT_DEFAULT,
        outline: null
      }
    },
    drawLine(attributes, paths) {
      return {
        geometry: {
          type: 'polyline',
          paths
        },
        symbol: {
          type: 'simple-line',
          color: 'red',
          width: 2
        },
        attributes
      }

    },
    removeGraphics() {
      EventBus.$emit('map-remove-graphics', {
        layerIds: this.mapLayers
      })
    },
    filterByVessel(attr) {
      this.removeGraphics()
      this.selectedVessel = this.selectedVessel || !attr ? null : {id: attr.id, name: attr.vessel_name}
      this.generateShipGraphics(this.vesselList.filter(item => this.selectedVessel ? item.vessel_name === this.selectedVessel.name : item));
      if(this.filteredTugboats && this.filteredTugboats.length > 0) {
        this.generateShipGraphics(this.filteredTugboats.filter(item => this.selectedVessel ? item.vessel_name === this.selectedVessel.name : item));
      } else {
        this.generateShipGraphics(this.tugboatList.filter(item => this.selectedVessel ? item.vessel_name === this.selectedVessel.name : item))
      }
      this.generatePoiGraphics(this.tugboatPositions);
    },

    // affected when separate location from api /tugboats-position 
    showDetail(attr) {
      this.isShipDetailShown = false
      if(attr.type === VESSEL_TYPE) {
        this.filterByVessel(attr)
      }

      const filterListWaterLevel = this.tugboatData
        .filter(v => v.id !== attr.id && v.water_level_past_7_days?.length)
        .map(k => ({
          text: k.name,
          value: k
        }))

      if ([KEY_POI_PORT, 'Bridge', 'Check Point'].includes(attr.poi_type)) {
        this.isCheckPoint = attr.poi_type === 'Check Point'
        this.isShipDetailShown = true
        this.isPopUpListShown = false

        if (attr.water_level_past_7_days?.length) {
          this.chartData.labels = attr.water_level_past_7_days
            ?.sort((a, b) => new Date(a.water_level_timestamp) - new Date(b.water_level_timestamp))
            ?.map(v => this.validateAndFormatDate(v.water_level_timestamp))
          this.chartData.datasets = [{
            type: 'line',
            label: attr.name,
            data: attr.water_level_past_7_days?.map(v => v.water_level),
            backgroundColor: attr.water_level_past_7_days?.map(v => `${v.water_level_color}80`)
          }]
          this.filterPoiOptions = filterListWaterLevel
        } else {
          this.chartData.labels = []
          this.chartData.datasets = [{
            type: 'line',
            label: attr.name,
            data: [],
            backgroundColor: []
          }]
          this.filterPoiOptions = []
        }

        if (attr.tonnage_past_7_days?.length) {
          const tonnageData = attr.tonnage_past_7_days
            .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
            .map((v) => v.tonnage === 0 ? null : v.tonnage)
          this.chartData.datasets = [
            ...this.chartData.datasets,
            {
              type: 'bar',
              label: attr.name,
              data: tonnageData,
              backgroundColor: '#4DA1A9',
              barThickness: 25,
              borderRadius: 8
            }
          ]
        }
      } else {
        this.isShipDetailShown = false
        this.isPopUpListShown = true
      }

      const type = attr.is_docking ? this.DOCKING_BARGE_TYPE() : attr.type === TUG_TYPE ? this.TUG_TYPE() : this.VESSEL_TYPE()
      this.detailType = type
      this.detail = this.selectedVessel || attr.type !== VESSEL_TYPE ?  attr : null
      const isShipTypeChange = this.popUpType !== type
      this.popUpType = isShipTypeChange ? type : this.popUpType
    },
    drawBridge(attr, path) {
      const point = {
        type: 'point',
        latitude: attr.latitude,
        longitude: attr.longitude
      }

      const iconGraphic = {
        geometry: point,
        symbol: {
          type: 'simple-marker',
          color: '#FF0000',
          path,
          size: 20
        },
        attr
      }

      const labelGraphic = {
        geometry: {
          type: 'point',
          latitude: attr.latitude + 0.0008, // adjust offset for zoom level
          longitude: attr.longitude
        },
        symbol: {
          type: 'text',
          text: attr.name || 'Bridge',
          color: 'black',
          font: {
            size: 8,
            family: 'Arial'
          },
          haloColor: 'white',
          haloSize: 1,
          yoffset: 10 // pushes text slightly above the marker
        },
        attributes: attr
      }

      return [iconGraphic, labelGraphic]
    },
    async setMapView(ship) {
      const lon = ship.longitude
      const lat = ship.latitude
      EventBus.$emit('map-set-view', { center: [lon, lat] })
    },
    onStatusCardFilter(status) {
      this.tugboatStatusFilter = this.tugboatStatusFilter === status ? null : status;
    },
    validateAndFormatDate(date, format = "DD") {
      if (!date || date === '-') {
        return null
      }
      const parsedDate = this.moment(date, ['DD-DD/M', 'YYYY-MM-DDTHH:mm:ss.SSSSZ', format], true)
      if (parsedDate.isValid()) {
        if (this.moment(date, format, true).isValid()) { // date already in correct format
          return date
        }
        return moment.utc(parsedDate).local().format(format)
      }
      return null;
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  @apply absolute;
  z-index: 9;
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.telematic-sidebar {
  @apply absolute;
  @apply right-0 flex flex-col justify-center items-center gap-5 cursor-pointer;
  @apply mr-5 px-3 py-5;
  @apply bg-primary;
  @apply rounded-md;
  z-index: 9;
  width: 4rem;
  top: 20%;

  img {
    width: 2.25rem;
    height: auto;
  }
}

.pop-up-container {
  @apply absolute;
  @apply pr-2;
  z-index: 9;
  right: 4rem;
}

.pop-up-detail-container {
  @apply absolute;
  @apply mt-20;
  @apply pl-5;
  z-index: 9;
  gap: 1rem;
}

</style>
